// list of compatible devices

import { Box, Button, CardMedia, Chip, Grid, Stack, Typography } from '@mui/material'
import Card from '@mui/material/Card'
import { useTranslation } from 'react-i18next'
import colors from '@/assets/scss/_themes-vars.module.scss'

export type MedconnectDeviceCardProps = {
  name: string
  logoSrc: string
  isLocal: boolean
  connectDevice: () => void
  restartDevice?: () => void
  deleteDevice?: () => void
  noButton?: boolean
}

export default function MedconnectDeviceCard(props: MedconnectDeviceCardProps) {
  const { name, logoSrc, connectDevice, restartDevice, deleteDevice, isLocal, noButton } = props

  const { t } = useTranslation()

  return (
    <Card sx={{
      p: '24px', '&:hover': {
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        border: `2px solid #28acb0`
      }
    }}
      onClick={() => connectDevice()}
    >
      <Grid container>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }} spacing={2}>
          <Grid item xs={6}>
            <Stack justifyContent="space-between" spacing={2}>
              <Box
                sx={{
                  display: 'flex',
                  width: noButton ? '150px' : '100px',
                  height: noButton ? '150px' : '100px',
                }}
              >
                <CardMedia
                  alt="device-image"
                  component="img"
                  data-testid="device-image"
                  src={logoSrc}
                  sx={{
                    width: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
              <Grid container spacing={2} direction="column" sx={{
                maxWidth: '80px',
              }} >
                <Grid item xs={6} md={6}>
                  <Typography variant="h6" component="div" sx={{ color: colors.gray900, fontSize: '18px', fontWeight: 500, lineHeight: '28px' }}>
                    {name}
                  </Typography>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
          {!noButton && <Grid item xs={6}>
            <Stack alignItems="end" justifyContent="space-between" sx={{ height: '100%' }} spacing={2}>
              {isLocal ? (
                <Chip color="success" label={t(`component.ui.deviceCard.installed.label`)} variant="filled" size="small" />
              ) : (
                <Chip color="primary" label={t(`component.ui.deviceCard.navigator.label`)} variant="filled" size="small" />
              )}
              <Stack direction="row" spacing={1}>
                <Button color="primary" disableElevation variant="contained" onClick={() => connectDevice()} size="small">
                  {t('component.ui.deviceCard.startButton.label')}
                </Button>
                {restartDevice && (
                  <Button color="secondary" disableElevation variant="contained" onClick={() => restartDevice()} size="small">
                    {t('component.ui.deviceCard.restart.label')}
                  </Button>
                )}
                {deleteDevice && (
                  <Button color="error" disableElevation variant="contained" onClick={() => deleteDevice()} size="small">
                    {t('component.ui.deviceCard.deleteButton.label')}
                  </Button>
                )}
              </Stack>
            </Stack>
          </Grid>}
        </Stack>
      </Grid>
    </Card>
  )
}
